// Manta Brand Colors
export const colors = {
  brand: {
    laranjaManta: '#E07B3D',
    terracota: '#C45A2B',
    marromQuente: '#8B4A2D',
    marromEscuro: '#5D3A1A',
  },
  semantic: {
    success: '#10b981',
    successLight: '#d1fae5',
    warning: '#f59e0b',
    warningLight: '#fef3c7',
    error: '#ef4444',
    errorLight: '#fee2e2',
    info: '#3b82f6',
    infoLight: '#dbeafe',
  },
  neutral: {
    white: '#ffffff',
    gray50: '#f9fafb',
    gray100: '#f3f4f6',
    gray200: '#e5e7eb',
    gray300: '#d1d5db',
    gray400: '#9ca3af',
    gray500: '#6b7280',
    gray600: '#4b5563',
    gray700: '#374151',
    gray800: '#1f2937',
    gray900: '#111827',
    black: '#000000',
  },
  chart: {
    primary: '#E07B3D',
    secondary: '#C45A2B',
    tertiary: '#8B4A2D',
    quaternary: '#5D3A1A',
    blue: '#3b82f6',
    green: '#10b981',
    yellow: '#f59e0b',
    red: '#ef4444',
    purple: '#8b5cf6',
    pink: '#ec4899',
    cyan: '#06b6d4',
    teal: '#14b8a6',
  },
} as const;

export const gradients = {
  header: 'linear-gradient(135deg, #5D3A1A 0%, #8B4A2D 50%, #E07B3D 100%)',
  headerReverse: 'linear-gradient(135deg, #E07B3D 0%, #8B4A2D 50%, #5D3A1A 100%)',
  sidebar: 'linear-gradient(180deg, #5D3A1A 0%, #8B4A2D 100%)',
  card: 'linear-gradient(135deg, #ffffff 0%, #f9fafb 100%)',
  success: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
  warning: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
  error: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
} as const;

export const shadows = {
  sm: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
  md: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
  lg: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
  xl: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)',
} as const;

export type BrandColor = keyof typeof colors.brand;
export type SemanticColor = keyof typeof colors.semantic;
export type NeutralColor = keyof typeof colors.neutral;
export type ChartColor = keyof typeof colors.chart;
